import { forwardRef, type CSSProperties } from 'react';
import * as StyledProgress from './styled/progress';

export type ProgressProps = StyledProgress.RootProps & {
  type?: 'linear' | 'circular';
  showDefaultText?: boolean;
  circleSize?: number;
  circleThickness?: number;
  trackColor?: string;
};

type CircularProgressCircleStyle = CSSProperties & {
  '--size'?: string;
  '--thickness'?: string;
};

export const Progress = forwardRef<HTMLDivElement, ProgressProps>(
  (props, ref) => {
    const {
      children,
      type = 'linear',
      showDefaultText = true,
      circleSize,
      circleThickness = 4,
      trackColor,
      ...rootProps
    } = props;

    const circularCircleStyle: CircularProgressCircleStyle | undefined =
      circleSize === undefined
        ? undefined
        : {
            '--size': `${circleSize}px`,
            '--thickness': `${circleThickness}px`,
            width: `${circleSize}px`,
            height: `${circleSize}px`,
          };

    return (
      <StyledProgress.Root ref={ref} {...rootProps}>
        {children && <StyledProgress.Label>{children}</StyledProgress.Label>}
        {type === 'linear' && (
          <StyledProgress.Track
            style={trackColor ? { backgroundColor: trackColor } : undefined}
          >
            <StyledProgress.Range />
          </StyledProgress.Track>
        )}
        {type === 'circular' && (
          <StyledProgress.Circle style={circularCircleStyle}>
            <StyledProgress.CircleTrack
              style={trackColor ? { stroke: trackColor } : undefined}
            />
            <StyledProgress.CircleRange />
            <StyledProgress.ValueText />
          </StyledProgress.Circle>
        )}
        {showDefaultText && <StyledProgress.ValueText />}
      </StyledProgress.Root>
    );
  },
);

Progress.displayName = 'Progress';
